module.exports = [
  null,
  'mandarin',
  'spanish',
  'english',
  'hindi',
  'arabic',
  'portuguese',
  'bengali',
  'russian',
  'japanese',
  'punjabi',
  'german',
  'javanese',
  'shanghainese',
  'malay',
  'telugu',
  'vietnamese',
  'korean',
  'french',
  'marathi',
  'tamil',
  'urdu',
  'turkish',
  'italian',
  'cantonese',
  'thai',
  'gujarati',
  'jin',
  'hokkien',
  'persian',
  'polish',
  'pashto',
  'kannada',
  'xiang',
  'malayalam',
  'sundanese',
  'hausa',
  'odia',
  'burmese',
  'hakka',
  'ukrainian',
  'bhojpuri',
  'tagalog',
  'yoruba',
  'maithili',
  'uzbek',
  'sindhi',
  'amharic',
  'fula',
  'romanian',
  'oromo',
  'igbo',
  'azerbaijani',
  'awadhi',
  'gan',
  'cebuano',
  'dutch',
  'kurdish',
  'serbo-croatian',
  'malagasy',
  'saraiki',
  'nepali',
  'sinhala',
  'chittagonian',
  'zhuang',
  'khmer',
  'turkmen',
  'assamese',
  'madurese',
  'somali',
  'marwari',
  'magahi',
  'haryanvi',
  'hungarian',
  'chhattisgarhi',
  'greek',
  'chewa',
  'deccan',
  'akan',
  'kazakh',
  'sylheti',
  'zulu',
  'czech',
  'kinyarwanda',
  'dhundhari',
  'haitian creole',
  'fuzhou',
  'ilocano',
  'quechua',
  'kirundi',
  'swedish',
  'hmong',
  'shona',
  'uyghur',
  'hiligaynon',
  'mossi',
  'xhosa',
  'belarusian',
  'balochi',
  'konkani'
];
